import { render, staticRenderFns } from "./ItemsOrderServiceList.vue?vue&type=template&id=65c40dac&scoped=true&"
import script from "./ItemsOrderServiceList.vue?vue&type=script&lang=js&"
export * from "./ItemsOrderServiceList.vue?vue&type=script&lang=js&"
import style0 from "./ItemsOrderServiceList.vue?vue&type=style&index=0&id=65c40dac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c40dac",
  null
  
)

export default component.exports